var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrevArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.443,
    height: 69.1,
    viewBox: "0 0 30.443 69.1",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    "data-name": "Trazado 264",
    d: "M-19886.084,581.333l-21.25,30.167,21.25,29.167",
    transform: "translate(19911.639 -576.456)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 7
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrevArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prevArrow.c396d60fc86b3d9d433e6848e932b3e7.svg";